import { TourismVehicleOutput } from './tourism-events-full/tourism-events-vehicle-add/tourism-events-vehicle-add.component';

export class TourismEvent {
	id: any;
	newId: any;
	created: string;
	status: string;
	type: string;
	drivers_departure: Array<any>;
	drivers_program: Array<any>;
	drivers_return: Array<any>;
	drivers_senior: Array<any>;
	sumValue: number;
	date_from: string;
	date_to: string;
	date_prepare: string;
	datePrepareAuto: boolean;
	program_date_from: string;
	program_date_to: string;
	planned_people_count: number;
	owner: Array<any>;
	organizationOwner: Array<any>;
	countries: Array<any>;
	name: string;
	category: CategoryEvent;
	crew_count: string;
	accommodation: string;
	text_departure: string;
	text_return: string;
	text_program: string;
	text_drivers: string;
	program_start_driver_place: string;
	program_end_driver_place: string;
	text_organization: string;
	text_client: string;
	text_refueling: string;
	text_billing: string;
	text_notes: string;
	tourist_guides_departure: Array<any>;
	tourist_guides_program: Array<any>;
	tourist_guides_return: Array<any>;
	tourist_guides_departure_periods: Array<TouristGuidePeriod>;
	tourist_guides_program_periods: Array<TouristGuidePeriod>;
	tourist_guides_return_periods: Array<TouristGuidePeriod>;
	tasks: Array<any>;
	briefingPlace: string;
	textBriefing: string;
	briefingUser: string;
	startPostCode: string;
	endPostCode: string;
	startPlace: string;
	startPlaceCity: string;
	startDate: string;
	endDate: string;
	endPlace: string;
	endPlaceCity: string;
	accommodation_detail: string;
	people: number;
	drivers: number;
	text_hotel: string;
	city_source: string;
	city_destination: string;
	// public driver_informed: boolean;
	driver_informed_departure: boolean;
	driver_informed_return: boolean;
	detail_about_first_day_confirmed: boolean;
	detail_about_last_day_confirmed: boolean;
	detail_about_program_confirmed: boolean;
	departure_place_confirmed: boolean;
	return_place_confirmed: boolean;
	services_confirmed: boolean;
	board_confirmed: boolean;
	services: boolean;
	night_confirmed: boolean;
	night: Array<any>;
	board: Array<any>;
	is_virtual_driver: number;
	text_opinion: string;
	date_deadline: string;
	dateDeadlineAuto: boolean;
	people_confirmed: boolean;
	client_wishes: string;
	client_representative: string;
	guide_informed: boolean;
	guide_informed_return: boolean;
	client_informed: boolean;
	text_guide: string;
	place_return: string;
	agreement_signature: string;
	agreement_value: number;
	agreement_value_currency: string;
	agreement_value_pln: number;
	predicted_profit: number;
	predicted_profit_currency: string;
	predicted_profit_pln: number;
	agreement_mileage_limit: number;
	invoiceRequired: boolean;
	invoiceRequiredNote: string;
	calculation_link: string;
	errorsCount: number;
	leadSource: number;
	note: string;
	client: any;
	clientEvent: ClientTourismEvent;
	reconciliation_type: number;
	reconciliation_comments: string;
	vehicles: EventVehicle[];
	ready_for_printing: boolean;
	was_printed: boolean;
}

export type TourismEventSavePayload = Omit<TourismEvent, 'vehicles'> & { vehicles: TourismVehicleOutput[] };

export interface EventVehicle {
	id: number;
	date_start: string;
	date_stop: string;
	vehicle_id: string;
}

export interface AccomodationKinds {
	id: string;
	name: string;
}

export interface ClientTourismEvent {
	client: string;
	event: string;
	isOrganization: string;
}

export enum CategoryEvent {
	OSKAR = 'OSKAR',
	SERVICE = 'SERVICE',
	ENSILAGE = 'ENSILAGE',
	ANTENNA = 'ANTENNA',
	DUTY = 'DUTY',
	OTHER = 'OTHER',
	RENT = 'RENT',
	FOREIGN = 'FOREIGN',
	GROUP = 'GROUP',
	FOREIGN_SCANDINAVIA = 'FOREIGN_SCANDINAVIA',
	EMPTY = 'EMPTY',
	FLEET = 'FLEET',
	TECHNICAL_EMPTY = 'TECHNICAL_EMPTY',
	WASH = 'WASH',
	ANTENNA_BUS = 'ANTENNA_BUS',
	MALFUNCTION = 'MALFUNCTION',
}

export const RentCategory = [
	CategoryEvent.RENT,
	CategoryEvent.FOREIGN,
	CategoryEvent.GROUP,
	CategoryEvent.FOREIGN_SCANDINAVIA,
];

export interface TermTourismEvent {
	id: number;
	eventId: string;
	kind: string;
	maxSeat: number;
}

export interface TouristGuidePeriod {
	touristGuide: string;
	date_from: string;
	date_to: string;
	dateFromAuto: boolean;
	dateToAuto: boolean;
}

export interface DriverEvent {
	driver: string;
	date_from: string;
	date_to: string;
	dateFromAuto: boolean;
	dateToAuto: boolean;
}

export interface Driver {
	dateFromAuto: boolean;
	dateToAuto: boolean;
	date_from: string;
	date_to: string;
	driver: {
		dateFromAuto: boolean;
		dateToAuto: boolean;
		date_from: string;
		date_to: string;
		driver: string;
	};
}

export enum DateKind {
	DATE_TO = 'date_to',
	DATE_FROM = 'date_from',
}

export enum EventStatus {
	PRELIMINARY = 'PRELIMINARY',
	CONFIRMED = 'CONFIRMED',
	EVENT = 'EVENT',
}

export enum EventClient {
	ORGANIZATION = '1',
	INDIVIDUAL_CUSTOMER = '0',
}
